import Vue from "vue";
import Router from "vue-router";
import Home from "./views/home/Home";
import GoddessSearch from "./views/home/GoddessSearch";
import Video from "./views/video/Video";
import VideoSearch from "./views/video/VideoSearch";
import VideoResult from "./views/video/VideoResult";
import Vip from "./views/vip/Vip";
import Message from "./views/message/Message";
import Chat from "./views/message/Chat";
import Personal from "./views/personal/Personal";
import PersonalHome from "./views/personal/PersonalHome";
import PopularizeRecord from "./views/vip/PopularizeRecord";
import Invite from "./views/vip/Invite";
import MyAttention from "@/views/personal/MyAttention";
import WatchHistory from "@/views/personal/WatchHistory";
import Setting from "@/views/personal/Setting";
import About from "@/views/personal/About";
import Order from "@/views/personal/Order";
import Service from "@/views/personal/Service";

import Login from "./views/login/Login";
import Protocol from "./views/login/Protocol";
import UserEditor from "@/views/personal/UserEditor";
import Layout from "@/components/Layout";
import Install from "@/views/home/Install";

// 重复跳转相同的路由会报 "NavigationDuplicated" 错误
// 利用原型链修改原本的push方法，过滤掉 "NavigationDuplicated" 错误
const push = Router.prototype.push;
Router.prototype.push = function(location) {
  return push.call(this, location).catch(err => {
    if (err.name === "NavigationDuplicated") {
      return;
    }
    console.error(err);
  });
};

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // 布局
    {
      path: "/",
      component: Layout,
      meta: {
        keepAlive: true
      },
      children: [
        {
          path: "",
          name: "home",
          component: Home,
          meta: {
            keepAlive: true
          }
        },
        {
          path: "video",
          name: "video",
          component: Video,
          meta: {
            keepAlive: true
          }
        },
        {
          path: "vip",
          name: "vip",
          component: Vip,
          meta: {
            keepAlive: true
          }
        },
        {
          path: "message",
          name: "message",
          component: Message,
          meta: {
            requireAuth: true,
            requireChat: true,
            keepAlive: true
          }
        },
        {
          path: "personal",
          name: "personal",
          component: Personal,
          meta: {
            requireAuth: false,
            keepAlive: true
          }
        }
      ]
    },

    // 首页
    {
      path: "/goddess/search",
      name: "goddessSearch",
      component: GoddessSearch
    },
    {
      path: "/video/play/:id",
      name: "videoPlay",
      component: () => import("./views/video/VideoPlay")
    },
    {
      path: "/video/search",
      name: "videoSearch",
      component: VideoSearch
    },
    {
      path: "/video/result/:value",
      name: "videoResult",
      component: VideoResult
    },
    {
      path: "/install",
      name: "install",
      component: Install
    },
    // VIP
    {
      path: "/popularize",
      name: "popularize",
      component: PopularizeRecord,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/invite",
      name: "invite",
      component: Invite,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/share",
      name: "share",
      component: () => import("./views/vip/Share")
    },
    // 消息
    {
      path: "/chat/:id",
      name: "chat",
      component: Chat,
      meta: {
        requireAuth: true,
        requireChat: true
      }
    },
    // 个人中心
    {
      path: "/personal/home/:id",
      name: "personalHome",
      component: PersonalHome
    },
    {
      path: "/user/editor",
      name: "userEditor",
      component: UserEditor,
      meta: {
        requireAuth: true,
        requireChat: true
      }
    },
    {
      path: "/attention",
      name: "myAttention",
      component: MyAttention,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/watchHistory",
      name: "watchHistory",
      component: WatchHistory
    },
    {
      path: "/setting",
      name: "setting",
      component: Setting,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/about",
      name: "about",
      component: About
    },
    {
      path: "/order",
      name: "order",
      component: Order,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/service",
      name: "service",
      component: Service
    },
    // 登录
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/login/protocol",
      name: "userProtocol",
      component: Protocol
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});
